/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EntityActivityKind = "EDUCATIONAL" | "GOVERNMENT_AGENCY" | "NON_PROFIT" | "PARTNERSHIP" | "PRIVATELY_HELD" | "PUBLIC_COMPANY" | "SELF_EMPLOYED" | "SELF_OWNED" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type SearchFacetInput = {
    readonly buckets?: ReadonlyArray<string> | null;
    readonly field: string;
    readonly size?: number | null;
    readonly sort?: string | null;
};
export type pitchPlanetQueryVariables = {
    readonly query: string;
    readonly cursor?: string | null;
    readonly facets?: ReadonlyArray<SearchFacetInput> | null;
    readonly filterQuery?: string | null;
    readonly order?: string | null;
};
export type pitchPlanetQueryResponse = {
    readonly pitchPlanet: {
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly facets: ReadonlyArray<{
            readonly buckets: ReadonlyArray<{
                readonly count: number | null;
                readonly value: string | null;
            }> | null;
            readonly name: string | null;
        }> | null;
        readonly items: ReadonlyArray<{
            readonly __typename: string;
            readonly id: string;
            readonly description: string | null;
            readonly title: string | null;
            readonly isPromoted: boolean | null;
            readonly trailer: {
                readonly externalId: string | null;
                readonly description: string | null;
                readonly durationInSeconds: number | null;
                readonly link: string | null;
            } | null;
            readonly originalClip: {
                readonly externalId: string | null;
                readonly durationInSeconds: number | null;
                readonly description: string | null;
                readonly link: string | null;
            } | null;
            readonly revision: string | null;
            readonly created: unknown | null;
            readonly label: string | null;
            readonly isDeleted: boolean | null;
            readonly isNew: boolean | null;
            readonly peopleEntities: ReadonlyArray<{
                readonly entity: {
                    readonly __typename: string;
                    readonly landingPageUrl: string | null;
                    readonly id: string;
                    readonly name: string | null;
                    readonly websiteUrl: string | null;
                    readonly fundingRound: string | null;
                    readonly industry: string | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly __typename: string;
                                readonly id: string;
                                readonly fullName: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly edges: ReadonlyArray<{
                                        readonly preview: {
                                            readonly link: string | null;
                                            readonly kind: PreviewKind | null;
                                            readonly mediaAsset: {
                                                readonly files: ReadonlyArray<{
                                                    readonly name: string | null;
                                                    readonly path: string | null;
                                                }> | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly previews: {
                        readonly edges: ReadonlyArray<{
                            readonly preview: {
                                readonly link: string | null;
                                readonly kind: PreviewKind | null;
                                readonly mediaAsset: {
                                    readonly files: ReadonlyArray<{
                                        readonly name: string | null;
                                        readonly path: string | null;
                                    }> | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
                readonly person: {
                    readonly __typename: string;
                    readonly landingPageUrl: string | null;
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly description: string | null;
                    readonly previews: {
                        readonly edges: ReadonlyArray<{
                            readonly preview: {
                                readonly link: string | null;
                                readonly kind: PreviewKind | null;
                                readonly mediaAsset: {
                                    readonly files: ReadonlyArray<{
                                        readonly name: string | null;
                                        readonly path: string | null;
                                    }> | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
            }> | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                                readonly label: string | null;
                            } | null;
                        } | null;
                    } | null;
                }> | null;
            } | null;
        }> | null;
    } | null;
};
export type pitchPlanetQuery = {
    readonly response: pitchPlanetQueryResponse;
    readonly variables: pitchPlanetQueryVariables;
};



/*
query pitchPlanetQuery(
  $query: String!
  $cursor: String
  $facets: [SearchFacetInput!]
  $filterQuery: String
  $order: String
) {
  pitchPlanet(query: $query, cursor: $cursor, facets: $facets, filterQuery: $filterQuery, order: $order) {
    hasErrors
    errors {
      id
      location
    }
    facets {
      buckets {
        count
        value
      }
      name
    }
    items {
      __typename
      id
      description
      title
      isPromoted
      trailer {
        externalId
        description
        durationInSeconds
        link
      }
      originalClip {
        externalId
        durationInSeconds
        description
        link
      }
      revision
      created
      label
      isDeleted
      isNew
      peopleEntities {
        entity {
          __typename
          landingPageUrl
          id
          name
          websiteUrl
          fundingRound
          industry
          people {
            count
            edges {
              role
              person {
                __typename
                id
                fullName
                landingPageUrl
                previews {
                  edges {
                    preview {
                      link
                      kind
                      mediaAsset {
                        files {
                          name
                          path
                          id
                        }
                        topLevelMediaType {
                          kind
                          id
                        }
                        id
                      }
                    }
                  }
                }
              }
            }
          }
          activities {
            kind
            label
            id
          }
          previews {
            edges {
              preview {
                link
                kind
                mediaAsset {
                  files {
                    name
                    path
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                  id
                }
              }
            }
          }
        }
        person {
          __typename
          landingPageUrl
          id
          fullName
          responsibility
          description
          previews {
            edges {
              preview {
                link
                kind
                mediaAsset {
                  files {
                    name
                    path
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                  id
                }
              }
            }
          }
        }
      }
      previews {
        count
        edges {
          cursor
          preview {
            link
            kind
            mediaAsset {
              id
              files {
                id
                name
                path
              }
              topLevelMediaType {
                kind
                label
                id
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "facets",
    "type": "[SearchFacetInput!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "filterQuery",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "order",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cursor",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "facets",
    "variableName": "facets"
  },
  {
    "kind": "Variable",
    "name": "filterQuery",
    "variableName": "filterQuery"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "facets",
  "storageKey": null,
  "args": null,
  "concreteType": "SearchFacet",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "buckets",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchFacetBucket",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v6/*: any*/)
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPromoted",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "externalId",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "trailer",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoDetails",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v9/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ]
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "originalClip",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoDetails",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v9/*: any*/),
    (v14/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isDeleted",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isNew",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fundingRound",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v28/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v6/*: any*/),
                    (v29/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": [
                    (v28/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v31 = [
  (v28/*: any*/),
  (v19/*: any*/)
],
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/),
    (v29/*: any*/)
  ]
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v28/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v6/*: any*/),
                    (v29/*: any*/),
                    (v3/*: any*/)
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": [
                    (v28/*: any*/),
                    (v3/*: any*/)
                  ]
                },
                (v3/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v36 = [
  (v28/*: any*/),
  (v19/*: any*/),
  (v3/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pitchPlanetQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pitchPlanet",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PitchVideoListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "items",
            "storageKey": null,
            "args": null,
            "concreteType": "PitchVideoStory",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "peopleEntities",
                "storageKey": null,
                "args": null,
                "concreteType": "EntityPerson",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "entity",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v22/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "people",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EntityOwnersConnection",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "EntityOwner",
                            "plural": true,
                            "selections": [
                              (v26/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "person",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Person",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v3/*: any*/),
                                  (v27/*: any*/),
                                  (v22/*: any*/),
                                  (v30/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "activities",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EntityActivity",
                        "plural": true,
                        "selections": (v31/*: any*/)
                      },
                      (v30/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "person",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Person",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v22/*: any*/),
                      (v3/*: any*/),
                      (v27/*: any*/),
                      (v32/*: any*/),
                      (v9/*: any*/),
                      (v30/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "previews",
                "storageKey": null,
                "args": null,
                "concreteType": "PreviewsConnection",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewEdge",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preview",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Preview",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v28/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "mediaAsset",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v34/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "topLevelMediaType",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TopLevelMediaType",
                                "plural": false,
                                "selections": (v31/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pitchPlanetQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pitchPlanet",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PitchVideoListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "items",
            "storageKey": null,
            "args": null,
            "concreteType": "PitchVideoStory",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "peopleEntities",
                "storageKey": null,
                "args": null,
                "concreteType": "EntityPerson",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "entity",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Entity",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v22/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "people",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EntityOwnersConnection",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "EntityOwner",
                            "plural": true,
                            "selections": [
                              (v26/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "person",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Person",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v3/*: any*/),
                                  (v27/*: any*/),
                                  (v22/*: any*/),
                                  (v35/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "activities",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EntityActivity",
                        "plural": true,
                        "selections": (v36/*: any*/)
                      },
                      (v35/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "person",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Person",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v22/*: any*/),
                      (v3/*: any*/),
                      (v27/*: any*/),
                      (v32/*: any*/),
                      (v9/*: any*/),
                      (v35/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "previews",
                "storageKey": null,
                "args": null,
                "concreteType": "PreviewsConnection",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewEdge",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preview",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Preview",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v28/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "mediaAsset",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaAsset",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v34/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "topLevelMediaType",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TopLevelMediaType",
                                "plural": false,
                                "selections": (v36/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pitchPlanetQuery",
    "id": null,
    "text": "query pitchPlanetQuery(\n  $query: String!\n  $cursor: String\n  $facets: [SearchFacetInput!]\n  $filterQuery: String\n  $order: String\n) {\n  pitchPlanet(query: $query, cursor: $cursor, facets: $facets, filterQuery: $filterQuery, order: $order) {\n    hasErrors\n    errors {\n      id\n      location\n    }\n    facets {\n      buckets {\n        count\n        value\n      }\n      name\n    }\n    items {\n      __typename\n      id\n      description\n      title\n      isPromoted\n      trailer {\n        externalId\n        description\n        durationInSeconds\n        link\n      }\n      originalClip {\n        externalId\n        durationInSeconds\n        description\n        link\n      }\n      revision\n      created\n      label\n      isDeleted\n      isNew\n      peopleEntities {\n        entity {\n          __typename\n          landingPageUrl\n          id\n          name\n          websiteUrl\n          fundingRound\n          industry\n          people {\n            count\n            edges {\n              role\n              person {\n                __typename\n                id\n                fullName\n                landingPageUrl\n                previews {\n                  edges {\n                    preview {\n                      link\n                      kind\n                      mediaAsset {\n                        files {\n                          name\n                          path\n                          id\n                        }\n                        topLevelMediaType {\n                          kind\n                          id\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          activities {\n            kind\n            label\n            id\n          }\n          previews {\n            edges {\n              preview {\n                link\n                kind\n                mediaAsset {\n                  files {\n                    name\n                    path\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n        person {\n          __typename\n          landingPageUrl\n          id\n          fullName\n          responsibility\n          description\n          previews {\n            edges {\n              preview {\n                link\n                kind\n                mediaAsset {\n                  files {\n                    name\n                    path\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n      previews {\n        count\n        edges {\n          cursor\n          preview {\n            link\n            kind\n            mediaAsset {\n              id\n              files {\n                id\n                name\n                path\n              }\n              topLevelMediaType {\n                kind\n                label\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '95fafd38e3f683ee551ef1c1191889c4';
export default node;
